// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__8vtwm","label":"Completed_label__3y_L3"};